module.exports = __webpack_public_path__ + "static/culture.time-6d9e4c6a31238ed32538b9bc8ad0b14b.png";